export default function getDomainName(domainName, port) {
  if(port) {
    return `localhost:${port}`;
  } else if (domainName.includes('staging')) {
    return 'staging.s3ntin3l.com';
  } else if (domainName.includes('dev')) {
    return 'dev.s3ntin3l.com'
  }
  return 'prod.s3ntin3l.com';
}